import { Component, OnInit } from '@angular/core';
import {FormControl} from '@angular/forms';
import {Observable} from 'rxjs/Observable';
import {SEARCH_TYPE_ACOPIO, SEARCH_TYPE_CUENTA, SearchService} from '@services/search-service';
import {MdDialogRef} from '@angular/material';

@Component({
  selector: 'app-remito-acopio-selector-autocomplete-dialog',
  templateUrl: './remito-acopio-selector-autocomplete-dialog.component.html',
  styleUrls: ['./remito-acopio-selector-autocomplete-dialog.component.scss', '../remitos-common-styles.scss']
})
export class RemitoAcopioSelectorAutocompleteDialogComponent implements OnInit {

  public acopios = [];
  public acopiosStateControl: FormControl;
  public filteredAcopios: Observable<any>;
  public selectedAcopios = [];

  constructor(
    private searchService: SearchService,
    public dialogRef: MdDialogRef<RemitoAcopioSelectorAutocompleteDialogComponent>
  ) {
    // Cuentas
    this.acopiosStateControl = new FormControl();
    this.filteredAcopios = this.acopiosStateControl.valueChanges
      .startWith(null)
      .debounceTime(1000)
      .switchMap(value => {
        if (value && value.length > 2){
          return this.searchService.searchAutocomplete(value, SEARCH_TYPE_ACOPIO);
        } else {
          return Observable.from([]);
        }
      })
      .map( value => {
        return value;
      });
  }

  ngOnInit() {
  }

  selectedAcopio($event, acopio) {
    this.dialogRef.close(acopio);
  }

}



// WEBPACK FOOTER //
// E:/jenkins_home/workspace/_agenda-unco-front-legacy_master/frontend-web/src/app/components/administracion/remitos/common/remito-acopio-selector-autocomplete-dialog/remito-acopio-selector-autocomplete-dialog.component.ts